package com.example.readingnotes.presentation.postdetail

import com.example.readingnotes.domain.model.Comment
import com.example.readingnotes.domain.model.Post

data class PostDetailState(
    val isLoading: Boolean = false,
    val errorMessage: String? = null,
    val post: Post? = null,
    val comments: List<Comment> = emptyList(),
    val authorNameInput: String = "",
    val commentInput: String = "",
    val isSubmittingComment: Boolean = false,
    val commentErrorMessage: String? = null,
    // Paid content states
    val isCreatingPurchaseSession: Boolean = false,
    val purchaseCheckoutUrl: String? = null,
    val showPurchaseDialog: Boolean = false,
    val purchaseErrorMessage: String? = null,
)
